import { createFileRoute } from "@tanstack/react-router";
import { SeoContentPage } from "@/components/SeoContentPage";
import { tossIndelingenSysteem } from "@/pages/seo-content";

const title = "Toss indelingen systeem & software voor tennisclubs | De Hussel App";
const description = "Toss indelingen systeem dat elke ronde automatisch en eerlijk indeelt. Toss indelingen software voor tennis- en padelverenigingen, zonder coördinator.";

export const Route = createFileRoute("/toss-indelingen-systeem")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/toss-indelingen-systeem" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/toss-indelingen-systeem" }],
  }),
  component: () => <SeoContentPage data={tossIndelingenSysteem} />,
});
